import React from 'react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Rajesh Kumar",
      role: "Business Owner",
      text: "I used just 5 strategies from this eBook and closed ₹2.5L in Diwali week! The WhatsApp automation alone saved me 3 hours daily.",
      rating: 5,
      avatar: "👨‍💼"
    },
    {
      name: "Priya Sharma",
      role: "Freelance Consultant",
      text: "The lead generation tactics are pure gold! I went from 2-3 leads per week to 15+ qualified prospects. My income doubled in just one month.",
      rating: 5,
      avatar: "👩‍💼"
    },
    {
      name: "Amit Patel",
      role: "Agency Owner",
      text: "Finally, a guide that actually works! The automation templates helped me scale from 10 to 50 clients without hiring more staff. Incredible ROI!",
      rating: 5,
      avatar: "👨‍💻"
    },
    {
      name: "Sneha Gupta",
      role: "Online Coach",
      text: "The Diwali campaign templates were a game-changer. I made ₹8L during the festive season using just the strategies from this eBook!",
      rating: 5,
      avatar: "👩‍🏫"
    },
    {
      name: "Vikram Singh",
      role: "Local Store Owner",
      text: "Even for a traditional business like mine, these digital strategies worked wonders. My foot traffic increased by 200% during Diwali!",
      rating: 5,
      avatar: "🏪"
    }
  ];

  return (
    <section id="testimonials" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            <span className="gradient-text">Success Stories</span> from Readers Like You 🌟
          </h2>
          <p className="text-lg text-gray-600">
            Real results from real people who took action
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-2xl shadow-lg card-hover"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="flex items-center mb-4">
                <div className="text-3xl mr-3">{testimonial.avatar}</div>
                <div>
                  <h4 className="font-semibold text-gray-800">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="flex items-center mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="text-yellow-400">⭐</span>
                ))}
              </div>
              
              <p className="text-gray-700 italic">"{testimonial.text}"</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;